import React, { FC } from 'react'

import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'

import {
  combineToggleAddFavoriteAction,
  combineToggleRemoveFavoriteAction,
} from 'actions/contactList/toggleFavoriteContactAction'
import { toggleUpdateForeignProfileAction } from 'actions/foreignProfile/foreignProfileAction'
import { foreignProfileSendWinkAction } from 'actions/foreignProfile/foreignProfileSendWinkAction'
import { useChatClickHandler } from 'components/block/ControlButtonsBar/hooks/useChatClickHandler'
import { ProfileActionPanel } from 'components/page/ForeignProfile/InteractiveButtons/ProfileActionPanel'
import { chatPath, contactPath, ProfileRouteParams } from 'components/paths'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useAuthorizationPath } from 'hooks/useAuthorizationLink'
import { useAuthorized } from 'hooks/useAuthorized'

export const InteractiveButtons: FC<{
  isWinked: boolean
  isFavourite: boolean | undefined
  place: string
}> = ({ isWinked, isFavourite, place }) => {
  const dispatch = useDispatch()
  const { userId } = useParams<ProfileRouteParams>()
  const _userId = Number(userId)
  const chatFullPath = mergeAllUrls(chatPath, userId, contactPath)
  const authorized = useAuthorized()
  const handleChatOpenClick = useChatClickHandler(_userId)

  const authorizationPath = useAuthorizationPath()

  const handleWink = () => {
    dispatch(foreignProfileSendWinkAction(_userId, isWinked))
  }

  const handleFavourite = async () => {
    if (!isFavourite) {
      await dispatch(combineToggleAddFavoriteAction(_userId, false))
    } else {
      await dispatch(combineToggleRemoveFavoriteAction(_userId))
    }

    dispatch(toggleUpdateForeignProfileAction(true))
  }

  return (
    <ProfileActionPanel
      isWinked={isWinked}
      authorized={authorized}
      isFavourite={isFavourite}
      chatPath={chatFullPath}
      authorizationPath={authorizationPath}
      onWink={handleWink}
      onChatOpen={handleChatOpenClick}
      onFavourite={handleFavourite}
      place={place}
    />
  )
}
